export default __webpack_public_path__ + "static/media/tajima.83646337.png";